import { e, T as a } from "./tss-DN0acMKN.mjs";
import { g as o } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { c as s } from "./createBox-58X037dC.mjs";
import { C as t } from "./generateUtilityClass-DMFG5-Cu.mjs";
const r = o("MuiBox", ["root"]), m = e(), f = s({
  themeId: a,
  defaultTheme: m,
  defaultClassName: r.root,
  generateClassName: t.generate
});
export {
  f as B
};
//# sourceMappingURL=Box-B5hjovXR.mjs.map
